const STATE_ID_KEY = 'state_id';

module.exports = { STATE_ID_KEY };
